/* eslint-disable */
import axios from 'axios'

/**
 * 定义请求常量
 * TIME_OUT、ERR_OK
 */
export const TIME_OUT = 88888888; // 请求超时时间
export const ERR_OK = '0'; // 请求成功返回状态，字段和后台统一
export const ERR_RELOGIN = 401; //重新登录状态
export const BASE_URL = process.env.BASE_URL // 引入全局url，定义在全局变量process.env中，值为空字符串
export const HOST_URL = process.env.HOST_URL // 引入全局url，定义在全局变量process.env中，值为空字符串
export const token = localStorage.getItem("token")
// 请求超时时间
axios.defaults.timeout = TIME_OUT

// 封装请求拦截
axios.interceptors.request.use(
	config => {
		config.headers['Content-Type'] = 'application/json;charset=UTF-8'
		return config
	},
	error => {
		return Promise.reject(error)
	}
)

// 封装响应拦截，判断token是否过期
axios.interceptors.response.use(
	response => {
		//拦截器状态      
		if(response.data.code == '90007') {
			// window.location.href = "http://www.welaiedu.cn/#/"
			return false
		}else{
			Interceptor(response.data.code)
			return response;
		}
	},
	error => {
		if(error.response) {
			//拦截器状态
			Interceptor(error.response.status)
		}
		// 返回接口返回的错误信息
		return Promise.reject(error.response.data)
	});

//拦截器状态
function Interceptor(i) {
	switch(i) {
		case 401:
			localStorage.clear()
			location.href = '/'
			break
	}
}

export default axios

// 封装post请求(requestUrl：域名公共部分,params：参数列表type:token类型ctype:上传数据格式类型)
export function POST(requestUrl, params = '', post, type, ctype) {
	//请求方式
	let method = post ? post : 'post'

	//默认登录token
	let token = window.localStorage.getItem('token')

	//token类型
	switch(type) {
		case 1: //注册token
			token = window.localStorage.getItem('regtoken')
			break
	}
	token = token != null ? token : ''
	//post请求
	if(method == 'post') {
		//设置Content-Type
		if(ctype == 1) {
			return axios({
				url: requestUrl,
				method: method,
				data: params,
				headers: {
					'token': token,
					'Content-Type': ctype,
					'appCode': 'YOUKE',
				}
			})
		} else if(ctype == 2) {
			return axios({
				url: requestUrl,
				method: method,
				params: params,
				headers: {
					'token': token,
					'appCode': 'YOUKE',
				}
			})
		}else if(ctype == 4) {
			return axios({
				url: requestUrl,
				method: method,
				params: params,
				headers: {
					'token': token,
					'Content-Type': 'multipart/form-data',
					'appCode': 'YOUKE',
				}
			})
		}else if(ctype == 3) {
			return axios({
				url: requestUrl,
				method: method,
				params: params,
				responseType: 'blob',
				headers: {
					'token': token,
					'appCode': 'YOUKE',
				}
			})
		} else {
			return axios({
				url: requestUrl,
				method: method,
				data: params,
				headers: {
					'token': token,
					'appCode': 'YOUKE',
				}
			})
		}

	} else {
		//get请求
		return axios({
			url: requestUrl,
			method: method,
			params: params,
			headers: {
				'token': token,
				'appCode': 'YOUKE',
			}
		})
	}
}
export function chuli(url, method, data) {

	//默认登录token
	let token = window.localStorage.getItem('token')
	if (method == 'post') {
		var xhr = new XMLHttpRequest();
		xhr.open('POST', url, false);        // 也可以使用POST方式，根据接口
		  // 返回类型blob
		xhr.setRequestHeader("token", token);
		xhr.setRequestHeader("content-type","application/x-www-form-urlencoded");
		// 发送ajax请求
		xhr.send(data)
		xhr.onload = function () {
			
		};

	}

}


// WEBPACK FOOTER //
// ./src/api/index.js